import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

interface RestoreGoodsRequest {
    product_idx: number[];
}

/*
// 삭제한 상품 복구. 삭제가 소프트 삭제라 상품번호(product_idx)가 그대로 살아나고,
// 그 상품으로 나간 과거 주문의 상품코드 표기도 함께 돌아온다.
*/
export const usePutGoodsRestore = (
    successCallback?: () => void,
): UseMutationResult<null, Error, RestoreGoodsRequest, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, Error, RestoreGoodsRequest>({
        mutationFn: async (restoreData: RestoreGoodsRequest) => {
            const response = await axios.put(`${enum_api_uri.put_product_restore}`, restoreData, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "application/json",
                },
            });
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getGoodsList"] });
            queryClient.invalidateQueries({ queryKey: ["getGoodsInfo"] });
            queryClient.invalidateQueries({ queryKey: ["getGoodsHistory"] });
            successCallback?.();
        },
    });
};
